"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var xIconSvg = function xIconSvg(props) {
  var size = props.size,
    color = props.color,
    className = props.className,
    onClick = props.onClick;
  return /*#__PURE__*/React.createElement("svg", {
    "data-provides": props['data-provides'],
    width: size,
    height: size,
    className: className,
    onClick: onClick,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "nonzero",
    d: "M11.0985261,8.72517045 L11.0985261,2.41146195 C11.0985261,1.8591772 10.6508108,1.41146195 10.0985261,1.41146195 C9.54624133,1.41146195 9.09852608,1.8591772 9.09852608,2.41146195 L9.09852608,8.72517045 L2.78481758,8.72517045 C2.23253283,8.72517045 1.78481758,9.1728857 1.78481758,9.72517045 C1.78481758,10.2774552 2.23253283,10.7251704 2.78481758,10.7251704 L9.09852608,10.7251704 L9.09852608,16.8834573 C9.09852608,17.4357421 9.54624133,17.8834573 10.0985261,17.8834573 C10.6508108,17.8834573 11.0985261,17.4357421 11.0985261,16.8834573 L11.0985261,10.7251704 L17.256813,10.7251704 C17.8090977,10.7251704 18.256813,10.2774552 18.256813,9.72517045 C18.256813,9.1728857 17.8090977,8.72517045 17.256813,8.72517045 L11.0985261,8.72517045 Z",
    transform: "rotate(45 10.02 9.647)"
  })));
};
var XIcon = (0, _styledComponents["default"])(xIconSvg).withConfig({
  displayName: "xicon__XIcon"
})(["vertical-align:", ";cursor:pointer;&:hover{path{fill:", ";}}"], function (props) {
  return props.verticalAlign;
}, function (props) {
  return props.hoverColor;
});
XIcon.displayName = 'XIcon';
var defaultProps = {
  size: '20px',
  color: _constants.colors.mediumGrey,
  hoverColor: _constants.colors.darkestGrey,
  verticalAlign: 'middle'
};
XIcon.defaultProps = defaultProps;
var _default = XIcon;
exports["default"] = _default;